import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";

// 🟢 Thunks
export const getAllCat = createAsyncThunk("categories/getAllCat", async () => {
  const response = await axiosClient.get("category/getAllCategory");
  return response.data.categoryList;
});

export const getEntertainCat = createAsyncThunk(
  "categories/getEntertainCat",
  async () => {
    const response = await axiosClient.get(
      "category/getAllEntertainmentCategory"
    );
    return response.data.data;
  }
);

// 🟡 Initial State
const initialState = {
  loadingCategories: false,
  error: null,
  categories: [],

  loadingEntertainmentCategories: false,
  entertainmentCategories: [],
  errorEntertainmentCategories: null,
};

// 🔵 Slice
const CategorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ✅ getAllCat
      .addCase(getAllCat.pending, (state) => {
        state.loadingCategories = true;
        state.error = null;
      })
      .addCase(getAllCat.fulfilled, (state, action) => {
        state.loadingCategories = false;
        state.categories = action.payload;
      })
      .addCase(getAllCat.rejected, (state, action) => {
        state.loadingCategories = false;
        state.error = action.error.message;
      })

      // ✅ getEntertainCat
      .addCase(getEntertainCat.pending, (state) => {
        state.loadingEntertainmentCategories = true;
        state.errorEntertainmentCategories = null;
      })
      .addCase(getEntertainCat.fulfilled, (state, action) => {
        state.loadingEntertainmentCategories = false;
        state.entertainmentCategories = action.payload;
      })
      .addCase(getEntertainCat.rejected, (state, action) => {
        state.loadingEntertainmentCategories = false;
        state.errorEntertainmentCategories = action.error.message;
      });
  },
});

// 🟢 Export Reducer & Actions
export default CategorySlice.reducer;
export const categoryActions = CategorySlice.actions;

// 🔵 Optional wrapper thunks (if you need them)
export const getCatdata = () => async (dispatch) => {
  await dispatch(getAllCat());
};

export const getEntertainmentCatdata = () => async (dispatch) => {
  await dispatch(getEntertainCat());
};
